<h2 *ngIf="data.title" mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button 
    *ngFor="let button of data.buttons" 
    mat-button 
    [mat-dialog-close]="button.value" 
    [ngClass]="button.color + '-btn'"
    >
    {{ button.title }}
  </button>
</mat-dialog-actions>
